import { styled } from 'styled-components';

import { _useDispatch, _useSelector } from '@src/state/hooks';
import Input from '@src/components/styled/Input';
import SmallButton from '@src/components/styled/SmallButton';

import _joinGame from '@src/io/events_out/_joinGame';

import _createGame from '@src/io/events_out/_createGame';
import useWagerApprove from '@src/hooks/useWagerApprove';
import useWagerAllowance from '@src/hooks/useWagerAllowance';
import { pushEventQueue, clearEventQueue } from '@src/state/slices/slice_game';

const Container = styled.div`
  position: relative;
  display: flex;
  // flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: 10pt;
  border: 2pt solid gray;
  padding-top: 10pt;
  padding-bottom: 10pt;

  width: 100%;
  min-width: 0;
  // overflow-y: scroll;

  // color hyperlink blue
  color: #0000ff;

  //background color windows 98 gray
  background-color: #c0c0c0;

  ${Input} {
    max-width: 14rem;
`;

const GameNameRow = styled.div`
  display: flex;
  max-width: 15rem;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const GameInfo = styled.div`
  max-width: 15rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 2rem;
  margin-bottom: 5pt;
`;
const QuestionMark = styled.div`
  font-size: 2rem;
  margin-bottom: 5pt;
`;

const Message = styled.div`
  text-align: center;
  max-width: 100%;
  font-size: 2rem;
`;

type Props = {
  gameId: string;
  gameWager: number;
  gameName: string;
};

export default function JoinGameForm(props: Props) {
  const dispatch = _useDispatch();

  const playerIsGeoblocked = _useSelector(
    (state) => state.app.playerIsGeoblocked,
  );

  const approve = useWagerApprove();
  const { data: allowance } = useWagerAllowance();

  const joinGame = () => {
    // if wagered, check allowance and make user approve if necessary
    if (
      props.gameWager &&
      (!allowance || parseFloat(allowance.toString()) < props.gameWager)
    ) {
      dispatch(
        pushEventQueue({
          message: 'Increase your $GOLD allowance to join a challenge game.',
          showToast: true,
          sound: 'yourTurn',
        }),
      );
      approve?.();
    } else {
      dispatch(clearEventQueue());
      _joinGame(props.gameId);
    }
  };

  return (
    <Container>
      {!playerIsGeoblocked && (
        <>
          <GameNameRow>
            <GameInfo>Join {props.gameName}</GameInfo>
            <QuestionMark>?</QuestionMark>
          </GameNameRow>
          <GameInfo>{props.gameWager} $GOLD</GameInfo>
          <SmallButton onClick={joinGame}>JOIN GAME</SmallButton>
        </>
      )}
      {playerIsGeoblocked && (
        <Message>This game is not available in your region.</Message>
      )}
    </Container>
  );
}
